/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 13 2019 11:05:35 PM
 *
 *******************************************************/
//@flow

import React from 'react';
import { Layout, Card, DisplayText, Button, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  title: string,
  src: string,
  buttonId: string,
  actionButton: () => void
};

type ComposedProps = Props & WithI18nProps;
// DONE
const LayoutCardComponent = (props: ComposedProps) => (
  <Layout.Section oneHalf>
    <Card sectioned>
      <div className="align-center card-title card-title-green">
        <DisplayText size="small">
          <TextStyle variation="strong">{props.title}</TextStyle>
        </DisplayText>
      </div>

      <img
        className="full-width"
        src={props.src}
        alt={props.i18n.translate('AdminHTML.Installation.OneDashSelectLayout.layoutCard_ImgAlt')}
      />

      <div className="align-center select-layout-button">
        <Button primary onClick={props.actionButton}>
          <span id={props.buttonId}>
            {props.i18n.translate(
              'AdminHTML.Installation.OneDashSelectLayout.layoutCard_ButtonChildren'
            )}
          </span>
        </Button>
      </div>
    </Card>
  </Layout.Section>
);

export const LayoutCard = withI18n()(LayoutCardComponent);
